export function createComponentPath(componentPath, componentName, order) {
  return [componentPath, componentName, order].filter(item => !!item).join('.');
}
